module.exports = __webpack_public_path__ + "img/Mizrahi45.1c7ee2c2.png";